import baseTheme from './base';
import { Theme } from './types';
export * from './types';

// NOTE: this technically starts as undefined, but allowing undefined is unhelpful when used correctly

const themes: { [id: string]: Theme; } = {
    default: baseTheme
};

export default themes;